import { lazy } from 'react';
import i18next from 'i18next';

import { PATHS, TRANSLATION_KEY } from './constants';
import { PERMISSIONS } from '../teams/constants/permissions';

const Billing = lazy(() => import('./Billing'));

['uk-UA', 'en-US'].forEach((lang) =>
  i18next.addResourceBundle(lang, TRANSLATION_KEY, require(`./i18n/${lang}`).default)
);

export const BillingConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: [PERMISSIONS.GetClientSubscription.value, PERMISSIONS.ClientSubscriptionAll.value],
  routes: [
    {
      path: PATHS.BILLING,
      element: <Billing />,
    },
  ],
};
